module.exports = __webpack_public_path__ + "static/media/tabbot-happy.440e47f8.png";